import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';

/**
 * A request in one table cell: its subject on top, the ID and workflow type under it.
 * Without a subject the workflow type moves up as the title.
 */
@Component({
  selector: 'lib-request-summary-cell',
  templateUrl: './request-summary-cell.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RequestSummaryCellComponent {
  readonly requestId = input<string | number | null>();
  readonly workflowType = input<string | null>();
  readonly subject = input<string | null>();

  protected readonly title = computed(
    () => this.subject()?.trim() || this.workflowType() || ''
  );
  /** The type stays on the second line only when the subject took the first. */
  protected readonly showTypeUnderTitle = computed(
    () => !!this.subject()?.trim() && !!this.workflowType()
  );
}
